var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"11","viewBox":"0 0 21 11","fill":"none","stroke":"currentcolor"}},[_c('line',{attrs:{"x1":"1","y1":"10","x2":"11","y2":"1","stroke":"currentcolor","stroke-width":"2"}}),_c('line',{attrs:{"x1":"20","y1":"10","x2":"10","y2":"1","stroke":"currentcolor","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }